import React,{useState} from 'react';
import { makeStyles } from "@material-ui/core/styles";
import {Card,CardContent,Box, Typography} from "@material-ui/core";
import NumberFormat from 'react-number-format';
const useStyles = makeStyles((theme) => ({
    card:{
      height:2.5+'rem',
      width:130,
     // padding:'1.1 rem 0px 1.12rem',
      marginRight:'.5em',
    },
       card3:{
        height:'3.8rem',
        width:100,
          color:"white",
        backgroundColor:process.env.REACT_APP_Fondo_Color,
        // padding:'1.1 rem 0px 1.12rem',
        marginRight:'.5em',
    },
    titulo:{
        //color:'#4a4a4a',
        textAlign:'center',
        marginTop:'-.4rem',
        fontSize:'1rem',
        fontWeight:600
    },
    tituloColor:{

        //color:'white',
        textAlign:'center',
        marginTop:'-.6rem',
        fontSize:'1rem',
        fontWeight:600
    },
    subtitulo:{
        //color:'#4a4a4a',
        textAlign:'center',
      
        fontSize:'.8rem',
    },
    subtituloCard:{
       // color:'#4a4a4a',
        textAlign:'center',
       
        fontSize:'.8rem',
    },
}));


export default function CardTotal({valor, }){
    const classes = useStyles();
    const[total,setTotal]= useState([])
    const auxColor=process.env.REACT_APP_Fondo_Color
    React.useEffect(()=>{
        console.log(valor);

        
   
        setTotal({ 
        })
    },[])  

    function generarCards(mensaje,datGen,datTot,auxColor){
        return( 
        < Box mr={1}>
            <p    style={{margin:0, padding:0, color:auxColor,textAlign:"center",fontWeight:700}} 
            >                
                      <NumberFormat value={datGen} displayType={'text'}  thousandSeparator={true}/>
                {' / '}
                <NumberFormat value={datTot} displayType={'text'}  thousandSeparator={true}/>
            </ p>
            <p  style={{margin:0, padding:0,textAlign:"center"}}>
                {mensaje}
            </p>
        </ Box>
        )
    }

    function generarCards2(mensaje,datGen,datTot,auxColor){
        return( 
        <CardContent>
            <Card className={classes.tituloColor} 
                style={{backgroundColor:auxColor,color:'white'}} 
            >                
                <NumberFormat value={datGen} displayType={'text'}  thousandSeparator={true}/>
                {' / '}
                <NumberFormat value={datTot} displayType={'text'}  thousandSeparator={true}/>
            </Card>
            <p className={classes.subtituloCard} >
                {mensaje}
            </p>
        </CardContent>
        )
    }
  
    function generarCards3(mensaje,datGen,datTot,auxColor){
        return( 
        <CardContent>
            <div //className={classes.tituloColor} 
                style={{ textAlign:'center',
        marginTop:'-.6rem',
        fontSize:'1rem',
        fontWeight:600}} 
            >                
                <NumberFormat value={datGen} displayType={'text'}  thousandSeparator={true}/>
                {' / '}
                <NumberFormat value={datTot} displayType={'text'}  thousandSeparator={true}/>
            </div>
            <p className={classes.subtituloCard} >
                {mensaje}
            </p>
        </CardContent>
        )
    }

    return ( 
        
    <Box display="flex" flexDirection="row" mb={1}ml={1}  >   
        {total.length!==0 ? 
        <Box display="flex" flexDirection="column">     
        <Typography color='primary'  style={{textAlign:"center",fontWeight:700}}>Avance General</Typography>                                          
            <Box display={"flex"} flexDirection={"row"}>
                {generarCards('Distrito',valor.AvcGralOp1, valor.AvcGralDto,  auxColor )}
            
         
                {generarCards('SubDistrito',valor.AvcGralOp2, valor.AvcGralBar,auxColor )}
        
        
                {generarCards('OTB',valor.AvcGralOp3, valor.AvcGralOtb,auxColor)}
            </Box>
          {/*   <Card className={classes.card}>
                {generarCards('Usuario RG',total?.UsrRG,'#58b85c')}
            </Card> */}
                       
        </Box>   
        :null}
    </Box>
    );
}
 